import { trackEvent } from "@faire/web--source/common/trackEvent";
import { trackSlateDesignSystemUiModalShowView } from "@faire/web-api--source/events/slateDesignSystem/view/uiModalShow";
import { useCallback, useEffect, useRef } from "react";
export var useTrackModalEvent = function(isOpen, postEventModalId) {
    var postedEvent = useRef(false);
    var postShowModalEvent = useCallback(function() {
        postedEvent.current = true;
        if (postEventModalId) {
            trackEvent("/ui/modal/show/".concat(postEventModalId));
            trackSlateDesignSystemUiModalShowView(postEventModalId);
        }
    }, [
        postEventModalId
    ]);
    useEffect(function() {
        if (isOpen && !postedEvent.current) {
            postShowModalEvent();
        }
    }, [
        isOpen,
        postShowModalEvent
    ]);
};
